
import { Component, Prop, Vue } from "vue-property-decorator";
import QuickAction from "@/components/V2/QuickActions/QuickAction.vue";
import { SMAdditionalInfo } from "@/store";

const MESSAGES = {
  title: "Quick Actions",
};

@Component({
  components: {
    QuickAction,
  },
})
export default class QuickActions extends Vue {
  @Prop({ type: Array, default: () => [] }) readonly items;
  @Prop({ type: Boolean, default: false }) readonly canStartDependantCase;

  MESSAGES = MESSAGES;

  get buttons() {
    if (!this.canStartDependantCase)
      return SMAdditionalInfo.filteredQuickActionsEmployee.filter(
        (a) => a.label !== "Buy Skilled Worker Dependant visa"
      );

    return SMAdditionalInfo.filteredQuickActionsEmployee;
  }
}
